export default [{
  path: '/choosingCenter',
  component: resolve => import(/* webpackChunkName: "entry" */ '../Index.vue').then(resolve),
  meta: {
    title: '选择登录中心',
    hideNav: true
  }
}]
